<template>
  <router-view />
</template>

<script setup>
import useSettingsStore from "@/store/modules/settings";
import { handleThemeStyle } from "@/utils/theme";

onMounted(() => {
  nextTick(() => {
    // 初始化主题样式
    handleThemeStyle(useSettingsStore().theme);
  });
});
</script>
<style lang="scss">
// table组件滚动条常显 样式强制覆盖
.el-table {
  .el-scrollbar {
    .el-scrollbar__bar {
      display: block !important;
      opacity: 1 !important;
    }

    &:hover .el-scrollbar__bar {
      display: block !important;
      opacity: 1 !important;
    }
  }
}
</style>
